/**
 * @component NotFoundPage
 * @description 유효하지 않은 URL 접근 시 사용자를 메인 경로로 안내하는 예외 페이지입니다.
 * @usage App 라우팅에서 정의되지 않은 경로가 들어올 때 렌더링됩니다.
 */

import PageHero from '../components/common/PageHero';
import { pageMeta } from '../constants/navigation';

export default function NotFoundPage({ onNavigate }) {
  return (
    <>
      <PageHero title={pageMeta.notFound.title} trail={pageMeta.notFound.trail} />
      <section className="section">
        <div className="container">
          <article className="not-found card-panel fade-in">
            <h2>페이지를 찾을 수 없습니다</h2>
            <p>요청하신 주소를 확인할 수 없습니다. 메인 페이지에서 다시 이동해주세요.</p>
            {/* [이벤트 처리]: 잘못된 경로에서 홈으로 안전하게 복귀시킵니다. */}
            <button type="button" className="primary-button" onClick={() => onNavigate('/')}>
              홈으로 이동
            </button>
          </article>
        </div>
      </section>
    </>
  );
}
